'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _ChooseFreeProduct = require('./ChooseFreeProduct');

var _ChooseFreeProduct2 = _interopRequireDefault(_ChooseFreeProduct);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App');

var FreeProduct = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(FreeProduct, _React$PureComponent);

    function FreeProduct() {
        (0, _classCallCheck3.default)(this, FreeProduct);
        return (0, _possibleConstructorReturn3.default)(this, (FreeProduct.__proto__ || (0, _getPrototypeOf2.default)(FreeProduct)).apply(this, arguments));
    }

    (0, _createClass3.default)(FreeProduct, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                products = _props.products,
                selectedIds = _props.selectedIds,
                onChange = _props.onChange;

            return _react2.default.createElement(
                'div',
                { className: 'cart__gift' },
                _react2.default.createElement(
                    'h2',
                    { className: 'mt-0' },
                    Resx.App.ChooseItemForFree
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    products.map(function (group) {
                        var discountCampaignId = group.id;
                        return _react2.default.createElement(_ChooseFreeProduct2.default, { key: discountCampaignId,
                            discountCampaignId: discountCampaignId,
                            products: group.freeProducts || [],
                            onChange: onChange,
                            selectedIds: selectedIds });
                    })
                )
            );
        }
    }]);
    return FreeProduct;
}(_react2.default.PureComponent), _class.propTypes = {
    products: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object).isRequired,
    selectedIds: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.number).isRequired,
    onChange: _react2.default.PropTypes.func.isRequired
}, _temp);
exports.default = FreeProduct;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step1/FreeProducts.js
// module id = 1020
// module chunks = 0